// extracted by mini-css-extract-plugin
export var brand = "_2j-9";
export var compact = "_2j-6";
export var extraSmall = "_2j-7";
export var icon = "_2j-0";
export var large = "_2j-4";
export var light = "_2j-1";
export var medium = "_2j-5";
export var outline = "_2j-b";
export var primaryDark = "_2j-a";
export var primaryLight = "_2j-8";
export var primaryModern = "_2j-c";
export var success = "_2j-2";
export var successSolid = "_2j-3";